export default __webpack_public_path__ + "static/media/directory-3.779192a0.jpeg";